import { Tag } from 'antd';
import { FC, memo } from 'react';

import { capitalizeString } from '@/common/utils';

import { DomainsApiProviders } from '@/modules/DomainsApi';

interface Props {
  provider: DomainsApiProviders;
}

export const DnsRecordsApiProviderTag: FC<Props> = memo(({ provider }) => {
  if (provider === DomainsApiProviders.Cloudflare) {
    return <Tag color="purple">{ capitalizeString(provider) }</Tag>;
  }
});
